var _circle, _circle2, _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotorSolutionTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#ED3431"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 10.5,
    fill: "#8E1F1D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 10.5,
    fill: "#8E1F1D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 19.5,
    r: 11.5,
    fill: "#5F1514"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.5 27C21.8513 27 27 21.8513 27 15.5C27 9.14873 21.8513 4 15.5 4C9.14873 4 4 9.14873 4 15.5C4 21.8513 9.14873 27 15.5 27Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7631 17.7284C24.7412 22.457 20.5343 26 15.4999 26C10.6243 26 6.52498 22.677 5.34306 18.1722C5.22462 18.1865 5.10405 18.1938 4.98176 18.1938C3.33504 18.1938 2 16.8629 2 15.2212C2 13.5795 3.33504 12.2485 4.98176 12.2485C5.15808 12.2485 5.33083 12.2638 5.49875 12.2931C6.85416 8.06253 10.8194 5 15.4999 5C20.0183 5 23.8702 7.85399 25.351 11.8576C25.5543 11.814 25.7653 11.791 25.9816 11.791C27.6283 11.791 28.9632 13.1219 28.9632 14.7636C28.9632 16.4054 27.6283 17.7363 25.9816 17.7363C25.9081 17.7363 25.8352 17.7336 25.7631 17.7284Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotorSolutionTop);
export default __webpack_public_path__ + "static/media/rotor-solution-top.acdbde991fd6d6306fff20049cac641b.svg";
export { ForwardRef as ReactComponent };